import PropTypes from 'prop-types'
import React, { PureComponent } from 'react'

import './index.css'
import { ParentContainer, TagContainer, TagParent } from './tag.styled'

export const getTagId = (id) => `${id}_tag`

class Tag extends PureComponent {
  static propTypes = {
    id: PropTypes.number.isRequired,
    label: PropTypes.string.isRequired,
    onDelete: PropTypes.func,
    readOnly: PropTypes.bool,
    disabled: PropTypes.bool,
    parent: PropTypes.number,
    parentParent: PropTypes.string,
    labelRemove: PropTypes.string
  }

  handleClick = (e) => {
    const { id, onDelete } = this.props
    e.stopPropagation()
    e.nativeEvent.stopImmediatePropagation()
    onDelete(id, (e.key || e.keyCode) !== undefined)
  }

  onKeyDown = (e) => {
    if (e.key === 'Backspace') {
      this.handleClick(e)
      e.preventDefault()
    }
  }

  onKeyUp = (e) => {
    if (e.keyCode === 32 || ['Delete', 'Enter'].indexOf(e.key) > -1) {
      this.handleClick(e)
      e.preventDefault()
    }
  }

  render() {
    const { id, label, labelRemove = 'Remove', readOnly, disabled, parent, parentParent } = this.props

    const tagId = getTagId(id)
    const buttonId = `${id}_button`
    const className = ['tag-remove', readOnly && 'readOnly', disabled && 'disabled'].filter(Boolean).join(' ')
    const isDisabled = readOnly || disabled

    return (
      <TagContainer className="tag" id={tagId} aria-label={label}>
        <ParentContainer>
          <TagParent>{parent ? `.${parent}` : ''}</TagParent>
          <TagParent>{parentParent ? `.${parentParent}` : ''}</TagParent>
        </ParentContainer>
        {label}
        <button
          id={buttonId}
          onClick={!isDisabled ? this.handleClick : undefined}
          onKeyDown={!isDisabled ? this.onKeyDown : undefined}
          onKeyUp={!isDisabled ? this.onKeyUp : undefined}
          className={className}
          type="button"
          aria-label={labelRemove}
          aria-labelledby={`${buttonId} ${tagId}`}
          aria-disabled={isDisabled}
        >
          x
        </button>
      </TagContainer>
    )
  }
}

export default Tag
